import { createContext } from 'react';
import { WidgetCategory } from '../types/DashboardLayoutTypes';

export const WidgetCategoryContext = createContext<WidgetCategory | null>(null);
